import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {DateFormatter, remoteOptionFormatter} from "../../../utils/formatters";
import {optionFilter} from "../../../utils/filters";

class TimeConfigList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "TimeConfigList"}
                {...props}
                columns={{
                    "location.name": {header: 'Helyszín', width: 4, sortable, filterable},
                    "repeatstart": {header: 'Ismétlés kezdete', width: 2, sortable, filterable, renderer: DateFormatter},
                    "repeatend": {header: 'Ismétlés vége', width: 2, sortable, filterable, renderer: DateFormatter},
                    "from_weekday": {header: 'Hét napjától', width: 1, sortable, filterable: optionFilter("weekday"), renderer: remoteOptionFormatter("weekday")},
                    "to_weekday": {header: 'Hét napjáig', width: 1, sortable, filterable: optionFilter("weekday"), renderer: remoteOptionFormatter("weekday")},
                    "from": {header: 'Mettől', width: 1, sortable, filterable},
                    "to": {header: 'Meddig', width: 1, sortable, filterable},
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default TimeConfigList;
